export const INSTANCE_COST_TABS = [
  'EC2',
  'RDS',
  'ElastiCache',
  'Redshift',
] as const;

export type InstanceCostTabs = typeof INSTANCE_COST_TABS[number];

export const INSTANCE_SERVICE_REPORT_MAP: Record<InstanceCostTabs, string> = {
  EC2: 'AmazonEC2',
  RDS: 'AmazonRDS',
  ElastiCache: 'AmazonElastiCache',
  Redshift: 'AmazonRedshift',
};

export const CLOUDWATCH_TABS = [
  'CloudWatch Logs',
  'CloudWatch Metrics',
] as const;

export type CloudwatchTabs = typeof CLOUDWATCH_TABS[number];

export const CLOUDWATCH_REPORT_TYPE_MAP: Record<CloudwatchTabs, string> = {
  'CloudWatch Logs': 'Logs',
  'CloudWatch Metrics': 'Metrics',
};

export const STORAGE_TABS = [
  'S3',
  'EBS Snapshot',
  'EBS Volumes',
  'EFS',
] as const;

export type StorageTabs = typeof STORAGE_TABS[number];

export const STORAGE_REPORT_MAP: Record<StorageTabs, string> = {
  S3: 'AmazonS3',
  EFS: 'AmazonEFS',
  'EBS Snapshot': 'AmazonSnapshot',
  'EBS Volumes': 'AmazonVolume',
};

export const SECURITY_TABS = ['GuardDuty', 'WAF'] as const;

export type SecurityTabs = typeof SECURITY_TABS[number];

export const SECURITY_REPORT_MAP: Record<SecurityTabs, string> = {
  GuardDuty: 'AmazonGuardDuty',
  WAF: 'awswaf',
};

export const DATA_TRANSFER_TOP10RESOURCES_TABS = [
  'Elastic Compute Cloud',
  'ELastic Load Balancing',
  'Simple Storage Service',
] as const;

export type Top10ResourcesTabs = typeof DATA_TRANSFER_TOP10RESOURCES_TABS[number];

export const SERVERLESS_REPORT_MAP = {
  SQS: 'AWSQueueService',
  LAMBDA: 'AWSLambda',
  SES: 'AmazonSES',
};

export const SERVERLESS_TABS = ['SQS', 'LAMBDA', 'SES'] as const;

export type ServerlessTabs = typeof SERVERLESS_TABS[number];

export const CONTAINER_TABS = ['ECR', 'EKS', 'ECS'] as const;

export type ContainerTabs = typeof CONTAINER_TABS[number];

export const NETWORK_TABS = ['API Gateway', 'Cloudfront'] as const;

export type NetworkTabs = typeof NETWORK_TABS[number];

export const NETWORK_REPORT_MAP: Record<NetworkTabs, string> = {
  'API Gateway': 'AmazonApiGateway',
  'Cloudfront': 'AmazonCloudFront',
};

export const ANALYTICS_TABS = ['Kinesis'] as const;

export type AnalyticsTabs = typeof ANALYTICS_TABS[number];

export const ANALYTICS_SERVICE_REPORT_MAP: Record<AnalyticsTabs, string> = {
  Kinesis: 'AmazonKinesis',
};

export const MIGRATION_TABS = ['DMS'] as const;

export type MigrationTabs = typeof MIGRATION_TABS[number];

export const MEDIA_SERVICES_TABS = ['MediaLive'] as const;

export type MediaServicesTabs = typeof MEDIA_SERVICES_TABS[number];

export const MEDIA_SERVICE_REPORT_MAP: Record<MediaServicesTabs, string> = {
  MediaLive: 'AWSElementalMediaLive',
};

export const CONTAINER_REPORT_MAP: Record<ContainerTabs, string> = {
  ECR: 'AmazonECR',
  EKS: 'AmazonEKS',
  ECS: 'AmazonECS',
};
